/**
 * Фильтры секций Справочников (Д9, эталон screen-21-dicts.js:54-58) — чистые
 * матчеры без сети. Семантика эталона: квест-фильтр приоритетен и матчит
 * ТОЛЬКО по квестам-потребителям; филиал-фильтр расходника матчит по квестам
 * И чайным выбранного филиала и по общему расходу филиала (05.10; операторы/
 * услуги не участвуют); у ресурса —
 * собственный branch_id ИЛИ квест филиала. Словари — живые данные (карты
 * привязок из useDictsAdmin + branch-принадлежность из useAppData), никаких
 * QBR/TEABR-констант. Карта не загрузилась (links null) → не прячем данные.
 */
import type { DictConsumable, DictResource } from "../api/dictTypes";

export interface DictFlt {
  br: string | null;
  q: string | null;
}
export const FLT0: DictFlt = { br: null, q: null };
export const fltActive = (f: DictFlt): boolean => !!(f.br || f.q);

/** consumable_id → id квестов (база) / чайных, потребляющих позицию. */
export interface ConsLinks {
  quests: Record<string, string[]>;
  teas: Record<string, string[]>;
  /** 05.10: id филиалов с общим расходом позиции. */
  branches?: Record<string, string[]>;
}

export function matchCons(
  item: DictConsumable,
  f: DictFlt,
  links: ConsLinks | null,
  questBr: Record<string, string>,
  teaBr: Record<string, string>,
): boolean {
  if (!f.br && !f.q) return true;
  if (!links) return true;
  const qs = links.quests[item.id] ?? [];
  if (f.q) return qs.includes(f.q);
  const ts = links.teas[item.id] ?? [];
  return qs.some((q) => questBr[q] === f.br) || ts.some((t) => teaBr[t] === f.br)
    || (links.branches?.[item.id] ?? []).includes(f.br as string);
}

export function matchRes(
  item: DictResource,
  f: DictFlt,
  links: Record<string, string[]> | null,
  questBr: Record<string, string>,
): boolean {
  if (!f.br && !f.q) return true;
  if (!links) return true;
  const qs = links[item.id] ?? [];
  if (f.q) return qs.includes(f.q);
  return item.branch_id === f.br || qs.some((q) => questBr[q] === f.br);
}
